export const GET_LESSON = 'lesson/get_lesson';
export const SUBMIT_ANSWERS = 'lesson/submit_answers';
export const TABS = {
  TOPIC: 'topic',
  VIDEO: 'video',
  QUIZ: 'quiz',
};